import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClientReportRoutingModule } from './client-report-routing.module';
import { ClientReportComponent } from './client-report.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { ClientReportInactiveComponent } from './client-report-inactive/client-report-inactive.component';
import { clientinactiveservice } from './client-report-inactive/client-report-inactive.service';
@NgModule({
  declarations: [ClientReportComponent,ClientReportInactiveComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MyDatePickerModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    DropDownListAllModule,
    ClientReportRoutingModule,
    dropdownModule
  ],
  providers : [clientinactiveservice]
})
export class ClientReportModule { }